import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from "@cinch-labs/design-system";
import { useCarReviewsHubTracking } from "@cinch-nx/data-tracking";
import { useEffect } from "react";
import NoReviewsImage from "./no-reviews-image.svg";
import styles from "./no-reviews.module.css";
export var NoReviews = function(param) {
    var selectedMake = param.selectedMake, selectedModel = param.selectedModel;
    var trackNoResultsFound = useCarReviewsHubTracking().trackNoResultsFound;
    useEffect(function() {
        if (!!selectedMake || !!selectedModel) {
            trackNoResultsFound("".concat(selectedMake, " ").concat(selectedModel ? selectedModel : "").trim());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedMake,
        selectedModel
    ]);
    return /*#__PURE__*/ _jsxs("section", {
        className: styles.container,
        "data-testid": "no-reviews",
        children: [
            /*#__PURE__*/ _jsx(NoReviewsImage, {
                className: styles.icon
            }),
            /*#__PURE__*/ _jsx(Text, {
                element: "h2",
                fontWeight: "bold",
                className: styles.header,
                children: "No results found"
            }),
            /*#__PURE__*/ _jsx(Text, {
                className: styles.body,
                children: "Sorry, we don’t have any reviews matching that. Please try some different filters."
            })
        ]
    });
};
